/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type thirdparty_ProductUpdateRequest = {
    active?: boolean;
    cost_price?: number;
    delivery_method?: string;
    external_sku?: string;
    fulfillment_type?: string;
    inventory_mode?: string;
    markup_percentage?: number;
    product_category?: thirdparty_ProductUpdateRequest.product_category;
    product_name?: string;
    stock_quantity?: number;
};
export namespace thirdparty_ProductUpdateRequest {
    export enum product_category {
        COURT = 'court',
    }
}

